import { doGet, doPost } from 'circe/Http/saga';
import { CREATE_URL, CREATE_EX_WORK_URL, CREATE_FORECAST_URL } from './constants';
import { shippingClient, operatorClient } from 'domain/HttpClients';

export const create = (formData, headers) =>
  doPost(CREATE_URL, formData, headers, {}, SHIPPING_EDGE, false, true);

export const createExWork = (formData, headers) =>
  doPost(CREATE_EX_WORK_URL, formData, headers, {}, SHIPPING_EDGE, false, true);

export const createForecast = (formData, headers) =>
  doPost(CREATE_FORECAST_URL, formData, headers, {}, SHIPPING_EDGE, false, true);

export const fetchFleets = (filters, headers) =>
  doGet(`${OPERATIONS_EDGE}/api/accounts/`, headers, false, {
    params: filters,
  });

export const fetchAddress = async (shipperId) => {
  try {
    const response = await shippingClient
      .Get('/api/address/v3/search')
      .withParams({ ownerId: shipperId })
      .send();

    const addresses = response?.results.map((address) => ({
      value: {
        name: address.name,
        location: {
          lat: address.location.coordinates.latitude,
          lng: address.location.coordinates.longitude,
        },
      },
      label: address.name,
    }));

    return addresses;
  } catch (e) {
    console.error(e);
    return [];
  }
};

export const getShippers = async (key) => {
  try {
    const response = await operatorClient
      .Get('api/shippers')
      .withParams({ did: SYSTEM_DOMAIN, firstName: key })
      .send();
    const output = response.results.map((row) => ({
      value: row.id,
      label: row.name,
      subLabel: row.company,
    }));
    return output;
  } catch (e) {
    console.error(e);
    return [];
  }
};
